import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui'
import { formatBaht } from '@/lib/money'
import type { Invoice } from '@/types'

interface InvoiceStatusBadgeProps {
  invoice: Pick<Invoice, 'status' | 'amount_paid'>
}

export function InvoiceStatusBadge({ invoice }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation('invoices')
  const status = invoice.status
  const variant = status === 'paid' ? 'success'
    : status === 'overdue' ? 'error'
    : status === 'partially_paid' ? 'info' : 'warning'
  const label = status === 'paid' ? 'status.paid'
    : status === 'overdue' ? 'status.overdue'
    : status === 'partially_paid' ? 'status.partially_paid' : 'status.unpaid'
  const showPaidAmount = (status === 'overdue' || status === 'partially_paid') && invoice.amount_paid > 0

  return (
    <div className="flex flex-col items-start gap-1">
      <Badge variant={variant}>{t(label)}</Badge>
      {showPaidAmount && (
        <span className="text-xs text-base-content/60">
          {t('status.paid_so_far', { amount: formatBaht(invoice.amount_paid) })}
        </span>
      )}
    </div>
  )
}
